import React, { useEffect, useState } from "react";
import styles from "../topic.module.css";

import { api } from "../../api/api";
import { normalizeToMapPoints } from "../../services/mapAdapter";
import { useModuleContext } from "../ModuleContext";
import { cachedLoad } from "../cache";

export default function PoiPanel() {
  const { language, showPoints, setLoading } = useModuleContext();

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  // ----------------------------
  // categories
  // ----------------------------
  useEffect(() => {
    let cancelled = false;

    api
      .category(language)
      .then((data) => !cancelled && setCategories(data))
      .catch((err) => console.error("Category load failed:", err));

    return () => {
      cancelled = true;
    };
  }, [language]);

  // ----------------------------
  // POIs of the selected category (re-runs on category or language change)
  // ----------------------------
  useEffect(() => {
    if (selectedCategory == null) return;

    let cancelled = false;
    setLoading(true);

    cachedLoad(`poi-${selectedCategory}-${language}`, async () => {
      const data = await api.poi(selectedCategory, language);
      return normalizeToMapPoints(data, "PointOfInterest");
    })
      .then((points) => !cancelled && showPoints(points))
      .catch((err) => console.error("POI load failed:", err))
      .finally(() => !cancelled && setLoading(false));

    return () => {
      cancelled = true;
    };
  }, [selectedCategory, language, showPoints, setLoading]);

  return (
    <div className={styles["poi-page"]}>

      {/* Kategorien */}
      <div className={styles.categories}>
        {categories.map((cat) => (
          <button
            key={cat.category_id}
            className={
              selectedCategory === cat.category_id
                ? `${styles.categoryBtn} ${styles.categoryBtnActive}`
                : styles.categoryBtn
            }
            onClick={() => setSelectedCategory(cat.category_id)}
          >
            {cat.icon_url && <img src={cat.icon_url} alt="" className={styles.categoryIcon} />}
            {cat.name}
          </button>
        ))}
      </div>
    </div>
  );
}
